module.exports = __webpack_public_path__ + "img/16.af4c5e72.jpg";